import { render, staticRenderFns } from "./TemplateCheckboxEditAreaComponent.vue?vue&type=template&id=6efada05&scoped=true&"
import script from "./TemplateCheckboxEditAreaComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateCheckboxEditAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efada05",
  null
  
)

export default component.exports